/* eslint-disable @typescript-eslint/no-explicit-any */
export function memoizeForHalfSecond<
  TArgs extends [...any],
  TReturn extends Promise<any>,
>(builder: (...args: TArgs) => TReturn): (...args: TArgs) => TReturn {
  let memoized: TReturn | null = null;

  return (...args: TArgs): TReturn => {
    if (!memoized) {
      // eslint-disable-next-line no-return-assign
      setTimeout(() => (memoized = null), 500);
      memoized = builder(...args);
    }

    return memoized;
  };
}
